import "./App.css";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  Container,
  Grid,
  Button,
  Paper,
  Stack,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { pink, indigo } from "@mui/material/colors";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

import Menu from "./components/Menu";
import DarkSwitch from "./components/DarkSwitch";

import ping from "./static/ping.wav";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import ThreeSixty from "./pages/ThreeSixty";
import MobileMenu from "./components/MobileMenu";
import About from "./pages/About";

function App() {
  document.addEventListener('contextmenu', e => e.preventDefault());
  ReactGA.initialize("G-G2MNDBCTGS");

  const [darkMode, setDarkMode] = useState(false);
  const [canPlaySounds, setCanPlaySounds] = useState(false);

  const audio = new Audio(ping);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: {
        main: darkMode ? pink[300] : pink[500],
      },
      secondary: {
        main: darkMode ? indigo[300] : indigo[500],
      },
    },
    components: {
      
    }
  });


  const toggleSound = () => {
    if (!canPlaySounds) audio.play();
    setCanPlaySounds(!canPlaySounds);
  };


  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Paper
          className="App"
          elevation={0}
          square
          style={{ minHeight: "100vh" }}
        >
          <MobileMenu darkMode={darkMode}/>
          <Container maxWidth="md">
          <Grid container justifyContent="center" mb={{xs: 0, sm:5}} pt={{xs: 10, sm:5}}>
              <img src={darkMode ? "./logo_dark.png" : "./logo_light.png"} alt="" style={{ maxWidth: 240 }} />
            </Grid>
            <Stack spacing={4}>
              <Menu darkMode={darkMode}/>
              {/* Begin COntent */}
              <Switch>
                <Route exact path="/">

                  <Home canPlaySounds={canPlaySounds} audio={audio} theme={theme} darkMode={darkMode}/>

                </Route>
                <Route path="/threesixty">
                      <ThreeSixty />
                </Route>
                <Route path="/about">
                      <About />
                </Route>
                <Route path="/contact">
                      <Contact />
                </Route>
              </Switch>
              {/* End content */}
            </Stack>
          </Container>
          <div className="modeSwitch">
            <Stack direction="row">
              <DarkSwitch
                onChange={() => {
                  setDarkMode(!darkMode);
                }}
              />
              <Button onClick={toggleSound} color="inherit">
                {canPlaySounds ? <VolumeUpIcon /> : <VolumeOffIcon />}
              </Button>
            </Stack>
          </div>
          <footer></footer>
        </Paper>
      </Router>
    </ThemeProvider>
  );
}

export default App;
